import { ScreenSelectView } from 'components/ScreenSelect/ScreenSelect.view';

export const ScreenSelect = ScreenSelectView;
